/**
 * Format phone number to display as +XX XXX (rest of number)
 * @param {string} phoneNumber - The phone number to format (e.g., "+4991196643231")
 * @returns {string} - Formatted phone number (e.g., "+49 911 96643231")
 */
export function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber || typeof phoneNumber !== 'string') {
        return phoneNumber;
    }

    // Remove any existing spaces and formatting
    const cleanNumber = phoneNumber.replace(/\s/g, '');
    
    // Check if it starts with +
    if (!cleanNumber.startsWith('+')) {
        return phoneNumber; // Return as-is if not international format
    }

    // Assume first two digits after + are the country code
    const countryCode = cleanNumber.substring(1, 3);
    const restOfNumber = cleanNumber.substring(3);

    // Format as +XX XXX (rest of number)
    if (restOfNumber.length >= 3) {
        const firstThree = restOfNumber.substring(0, 3);
        const remaining = restOfNumber.substring(3);

        return `+${countryCode} ${firstThree} ${remaining}`;
    }

    return `+${countryCode} ${restOfNumber}`;
}
